import script from "./ObjectivesEmptyHero.vue?vue&type=script&lang=js"
export * from "./ObjectivesEmptyHero.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__